<template>
  <div>
  <myHeader></myHeader>

    <div class="webTrichotherapy">
      <h2>Trichotherapy</h2>
      <div class="webTricoImg">
        <img src="../../assets/PrestationSoin1.jpeg" alt="Trichotherapy">
      </div>
      <br>
      <h3 class="webMentionsCenter">Qu’est-ce que la coupe Authentique vibratoire ?</h3>
      <br>
      <p class="webTricoDescription webMentionsCenter">La coupe authentique se déroule en plusieurs actes… C’est en tout
        premier lieu, une invitation au voyage intérieur, sensible et sensitive à travers un modelage crânien, une coupe
        énergétique et vibratoire, une coupe harmonisante, un lissage embellissant…</p>
      <p class="webTricoDescription webMentionsCenter"> Je vous invite à découvrir ce soin énergétique plus en détails :
      </p>
      <br>
      <h3>1. Un massage crânien-sacré :</h3>
      <p class="webTricoline1">C’est un massage sensitif et sensoriel, où se rencontrent plusieurs gestes issus de
        l’ayurveda (Inde), shiatsu (Japon) et énergétique (Universelle) </p>
      <p class="webTricoline1">La base de la beauté passe par le cuir chevelu ! D’où l’importance du massage.</p>
      <p class="webTricoline1">Le massage permet de préparer la personne à recevoir le soin, elle est invitée à
        s’abandonner…un profond lâcher-prise pour se reconnecter avec son monde intérieur (mémoires), réceptivité, au soi
        profond.</p>
      <br>
      <p class="webTricoline2">Le massage crânien, une invitation au calme intérieur, un retour à soi…</p>
      <br>
      <p class="webTricoline2">Ses bienfaits :</p>

      <p class="webTricoline1">– Il stimule la microcirculation, il favorise une bonne irrigation des bulbes capillaires
        pour des cheveux fortifiés, en meilleur santé</p>
      <p class="webTricoline1">– Il agit sur le cuir chevelu comme un anti-stress.</p>
      <p class="webTricoline1">– Réveille et active les méridiens crâniens</p>
      <p class="webTricoline1">– L’énergie vitale est relancée</p>
      <p class="webTricoline1">– Réconforte et sécurise</p>
      <p class="webTricoline1">– Amène un sentiment de bien-être, de lâcher prise</p>
      <p class="webTricoline1">– Libère les tensions corporelles et psychiques</p>
      <p class="webTricoline1">– Optimise l’oxygénation et assouplit le cuir chevelu pour aider à la (re)pousse des cheveux
        et l’élimination des toxines.</p>
      <p class="webTricoline1">– Soulage et atténue les contractions présente dans le corps</p>

      <h3>2. La coupe Authentique Vibratoire</h3>
      <p class="webTricoline1">C’est une phase de nettoyage, de rééquilibrage, cela vient résonner sur plusieurs aspects, le
        physique, l’émotionnelle et l’énergétique. On facilite la détoxination du cuir chevelu et des cheveux, un
        rééquilibrage au niveau des corps énergétiques et émotionnels, ainsi la personne peut, si elle le souhaite, se
        débarrasser naturellement, se départir de ces lourdeurs, qui lui apporteront un sentiment de légèreté, un nouveau
        souffle de vitalité. </p>
      <p class="webTricoline1">Cette coupe authentique s’initie dans un mouvement d’ouverture en lien avec cette vibration
        sacrée qui représente le symbole de l’infini… Ce mouvement de 8 qui se fait naturellement dans le corps.</p>
      <p class="webTricoline1">On enlève que très peu de cheveux dans cette phase, le but étant la stimulation vibratoire
        qui invite le cheveu, le corps et l’être à s’unifier</p>

      <h3>3. La coupe harmonisante</h3>
      <p class="webTricoline1">C’est une phase esthétique, elle recrée de la structure, de l’harmonie, du lien dans le
        cheveu, elle le respecte.</p>
      <p class="webTricoline1">Elle écoute ces mouvements, ces volumes, ses directions sans le contredire, selon vos
        aspirations, vos envies.</p>

      <h3>4. Le Lissage vibratoire</h3>
      <p class="webTricoline1">C’est une phase d’unification, l’embellissant naturel des cheveux. Cette deuxième vibration
        est plus douce, plus enveloppante.</p>
      <p class="webTricoline1">Les cheveux retrouvent leurs pouvoirs de connexion et de réceptivité</p>
      <p class="webTricoline1">La résonance vibratoire est plus subtile dans la gestuelle, la position de la lame est
        adaptée pour venir réparer et nourrir la fibre du cheveu.</p>
      <p class="webTricoline1">Son rôle est de sublimer le cheveu, en révélant sa puissance, son intensité, sa luminosité,
        un sentiment de légèreté, de souplesse, de fluidité, vos cheveux retrouvent leur vitalité !</p>

      <h3>Les bienfaits de la coupe authentique vibratoire</h3>
      <p class="webTricoline2">Réalisée au rythme de la lune et des saisons selon vos besoins.</p>
      <br>
      <p class="webTricoline1 webTricolineEffect1">Apporte un calme intérieur, une harmonie, le sentiment d’être centré,
        ancré, équilibré, léger</p>
      <p class="webTricoline1 webTricolineEffect1">L’énergie de vie est activée, impulsée et stimulée</p>
      <p class="webTricoline1 webTricolineEffect1">Libère la libre circulation des fluides dans le corps</p>
    <p class="webTricoline1 webTricolineEffect1">Redonne une amplitude à la respiration du corps et de l’esprit</p>
    <p class="webTricoline1 webTricolineEffect1"> Rééquilibre, réaligne et ré-ouvre le champ vibratoire des centres
      énergétiques et corps subtils</p>
    <p class="webTricoline1 webTricolineEffect1">Débarrasse le cheveu des impuretés capillaires, émotionnelles et
      énergétiques.</p>
    <p class="webTricoline1 webTricolineEffect1">Les cheveux retrouvent vitalité, croissance et force, grâce à
      l’activation de la circulation sanguine et à l’oxygénation du cheveu</p>
    <p class="webTricoline1 webTricolineEffect1">Invitation à se reconnecter à son instinct, son intuition, sa
      connaissance, sa réceptivité</p>
    <p class="webTricoline1 webTricolineEffect1">Harmonise les différentes polarités de l’être et le relie harmonieusement
      à l’univers qui l’entoure</p>
    <p class="webTricoline1 webTricolineEffect1">Unifier son masculin et son féminin</p>
    <p class="webTricoline1 webTricolineEffect1">Permet de décristalliser, libérer les charges émotionnelles et les
      blocages engrammés dans le cheveu et le corps.</p>
    <p class="webTricoline1 webTricolineEffect1">Un soin holistique et global du corps et de l’être.</p>
    <br>
    <br>
    <div class="webTarifSoinLink">
      <a class="webTarifTitle" @click.prevent="goPrevious()"> Retour</a>
    </div>
  </div>

  <myFooter></myFooter>
  </div>
</template>

<script>
export default {
  name: 'webTrichotherapy',
  data () {
    return {
    }
  },
  methods: {
    goPrevious () {
      this.$router.push('/Tarifs/Soins-Energetiques')
    }
  }
}
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/SiteWeb/WebTricho.vue